import React, {useEffect} from 'react';
import {Link} from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NavHashLink } from 'react-router-hash-link';
import './Header.sass'
import Logo from "./Logo"
import {Menu, MenuItem, useMediaQuery, useTheme} from "@mui/material";
import HeaderDrawer from "./HeaderDrawer";

export const NavLink = ({to, children, className, offset}) => (
    <NavHashLink
        to={to}
        className={className ? className : 'header__nav__item'}
        scroll={offset}
    >
        {children}
    </NavHashLink>
)

function Header() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        function resizeHeaderOnScroll() {
          const distanceY = window.pageYOffset || document.documentElement.scrollTop;
          const shrinkOn = 10;
          const headerLogo = document.getElementsByClassName("header__logo")[0];
          const headerContainer = document.getElementsByClassName("header")[0];
          const header = document.querySelector("header");
          const hamburgers = document.querySelectorAll(".hamburger_line");

          if (distanceY > shrinkOn) {
            headerLogo.classList.add("scrolled");
            headerContainer.classList.add("scrolled");
            header.classList.add("scrolled");
            hamburgers.forEach(hamburger => hamburger.classList.add("scrolled"));
          } else {
            headerLogo.classList.remove("scrolled");
            headerContainer.classList.remove("scrolled");
            header.classList.remove("scrolled");
            hamburgers.forEach(hamburger => hamburger.classList.remove("scrolled"));
          }
        }

        window.addEventListener("scroll", resizeHeaderOnScroll);
    }, []);

    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    return (
        <div className={'header'}>
            <header className={isMobile && 'header_mobile'}>
                <NavLink to="/#" className="header__logo">
                  <Logo />
                </NavLink>

                {
                    isMobile ? (
                        <HeaderDrawer />
                    ) : (
                        <ul className="header__nav">
                            <NavLink to="/#about" offset={el => scrollWithOffset(el)}>
                                about
                            </NavLink>
                            <NavLink to="/#work">
                                work
                            </NavLink>
                            <NavLink to="/#contact">
                                contact
                            </NavLink>

                            <button
                                className='header__nav__item header__nav__item__more'
                                onClick={handleClick}
                                aria-controls={open ? 'more-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                            >
                                more
                                <ExpandMoreIcon />
                            </button>
                        </ul>
                    )
                }

                <Menu
                    anchorEl={anchorEl}
                    id="more-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    disableScrollLock={true}
                    autoFocus={false}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <Link to={'/more'}>
                        <MenuItem>
                            more about me
                        </MenuItem>
                    </Link>
                    {/*<Link to={'/work'}>*/}
                    {/*    <MenuItem>*/}
                    {/*        more work*/}
                    {/*    </MenuItem>*/}
                    {/*</Link>*/}
                    <a href={'https://drive.google.com/file/d/1_TtgR3HEABau-rBxm2rdvUe7dTN5yFeT/view'}>
                        <MenuItem>
                            resume
                        </MenuItem>
                    </a>
                </Menu>

              </header>
        </div>
    );
}

export default Header;